/* IDIKO — Cart drawer extras: free-shipping bar + cross-sell
   Solo inyecta dentro del drawer. NUNCA en <main> ni el body.
*/
(function(){
  const FREE_SHIPPING_THRESHOLD = 2500; /* céntimos = 25€ */
  const RECOMMENDED_HANDLES = [
    'champu-daily-uso-diario',
    'treatwell-arganoil-100ml',
    'leave-intense-200ml',
    'glow-protect',
    'mascarilla-treatwell-200ml'
  ];

  let recommendedCache = null;

  function money(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  }

  async function fetchCart(){
    try { const r = await fetch('/cart.js', { credentials: 'same-origin' }); return await r.json(); }
    catch(e) { return null; }
  }

  async function fetchProduct(handle){
    try { const r = await fetch('/products/' + handle + '.js'); return r.ok ? await r.json() : null; }
    catch(e) { return null; }
  }

  async function loadRecommended(){
    if (recommendedCache) return recommendedCache;
    const products = await Promise.all(RECOMMENDED_HANDLES.map(fetchProduct));
    recommendedCache = products.filter(Boolean);
    return recommendedCache;
  }

  /* El drawer real es el <dialog>, no el wrapper cart-drawer-component */
  function findDialog(){
    return document.querySelector('.cart-drawer__dialog')
        || document.querySelector('cart-drawer-component dialog')
        || null;
  }

  function dialogIsOpen(dialog){
    if (!dialog) return false;
    if (dialog.hasAttribute('open')) return true;
    if (dialog.open) return true;
    return false;
  }

  function findInjectionPoint(dialog){
    return dialog.querySelector('.cart-drawer__content')
        || dialog.querySelector('.cart-drawer__inner')
        || dialog;
  }

  function buildShippingBar(cart){
    const total = cart.total_price;
    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);
    const pct = Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100);
    const complete = remaining === 0 && total > 0;

    let bar = document.createElement('div');
    bar.className = 'idk-shipping-bar';
    bar.innerHTML = `
      <p class="idk-shipping-bar__text"></p>
      <div class="idk-shipping-bar__track">
        <div class="idk-shipping-bar__progress"></div>
      </div>`;

    const text = bar.querySelector('.idk-shipping-bar__text');
    const progress = bar.querySelector('.idk-shipping-bar__progress');

    if (complete) {
      bar.classList.add('is-complete');
      text.innerHTML = '<span class="idk-shipping-bar__icon">✓</span> ¡Envío <strong>gratis</strong> conseguido!';
    } else if (total === 0) {
      text.innerHTML = `Envío gratis a partir de <strong>${money(FREE_SHIPPING_THRESHOLD)}</strong>`;
    } else {
      text.innerHTML = `Te faltan <strong>${money(remaining)}</strong> para envío gratis`;
    }
    progress.style.width = pct + '%';
    return bar;
  }

  function buildCrossSell(products, cart){
    const handlesInCart = new Set((cart.items || []).map(i => i.handle));
    const filtered = products.filter(p => !handlesInCart.has(p.handle)).slice(0, 6);
    if (!filtered.length) return null;

    const wrap = document.createElement('div');
    wrap.className = 'idk-cross-sell';
    wrap.innerHTML = `
      <p class="idk-cross-sell__title">Completa tu carrito</p>
      <ul class="idk-cross-sell__list"></ul>`;
    const list = wrap.querySelector('ul');

    filtered.forEach(p => {
      const variantId = p.variants[0].id;
      const li = document.createElement('li');
      const img = (p.featured_image || (p.images && p.images[0]) || '');
      li.innerHTML = `
        <a class="idk-cross-sell__card" href="${p.url}">
          <div class="idk-cross-sell__media">
            <img src="${img}" alt="${p.title}" loading="lazy">
          </div>
          <div class="idk-cross-sell__info">
            <h4 class="idk-cross-sell__name">${p.title}</h4>
            <div class="idk-cross-sell__row">
              <span class="idk-cross-sell__price">${money(p.price)}</span>
              <button class="idk-cross-sell__add" type="button" data-variant="${variantId}" aria-label="Añadir">+</button>
            </div>
          </div>
        </a>`;
      list.appendChild(li);
    });

    list.querySelectorAll('.idk-cross-sell__add').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation();
        const id = btn.dataset.variant;
        btn.disabled = true; btn.textContent = '…';
        try {
          /* Pedimos a Shopify que devuelva la sección renderizada para refrescar el drawer */
          const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(id), quantity: 1 }],
              sections: sectionId
            })
          });
          const data = await resp.json();

          /* Reemplazar el contenido del drawer con el HTML actualizado */
          if (data && data.sections && sectionId && data.sections[sectionId]) {
            replaceCartDrawer(data.sections[sectionId]);
          }

          btn.classList.add('is-added');
          btn.textContent = '✓';
          /* Re-render nuestras extras (shipping bar + cross-sell) tras el reemplazo */
          setTimeout(()=>renderExtras(), 100);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (err) { btn.textContent = '!'; }
        setTimeout(()=>{ btn.disabled=false; btn.textContent='+'; btn.classList.remove('is-added'); }, 1800);
      });
    });

    return wrap;
  }

  /* Reemplaza el contenido del cart-drawer-component manteniendo abierto el dialog */
  function replaceCartDrawer(htmlString){
    const tmp = document.createElement('div');
    tmp.innerHTML = htmlString;
    const newCdc = tmp.querySelector('cart-drawer-component');
    const oldCdc = document.querySelector('cart-drawer-component');
    if (!newCdc || !oldCdc) return;

    const wasOpen = oldCdc.querySelector('.cart-drawer__dialog')?.hasAttribute('open');

    /* Reemplazar solo el contenido del dialog, no el wrapper completo (el wrapper contiene el botón del icono) */
    const oldDialog = oldCdc.querySelector('.cart-drawer__dialog');
    const newDialog = newCdc.querySelector('.cart-drawer__dialog');
    if (oldDialog && newDialog) {
      oldDialog.innerHTML = newDialog.innerHTML;
      if (wasOpen && oldDialog.showModal && !oldDialog.hasAttribute('open')) {
        oldDialog.showModal();
      }
    }

    /* Actualizar el cart bubble (contador del icono) */
    const oldBubble = oldCdc.querySelector('cart-bubble, .cart-bubble, [class*="cart-bubble"]');
    const newBubble = newCdc.querySelector('cart-bubble, .cart-bubble, [class*="cart-bubble"]');
    if (oldBubble && newBubble) {
      oldBubble.outerHTML = newBubble.outerHTML;
    }
  }

  async function renderExtras(){
    const dialog = findDialog();
    if (!dialog) return;
    if (!dialogIsOpen(dialog)) return;

    const inner = dialog.querySelector('.cart-drawer__inner');
    if (!inner) return;

    const cart = await fetchCart();
    if (!cart) return;

    /* Limpiar inyecciones previas en el dialog */
    dialog.querySelectorAll('.idk-shipping-bar, .idk-cross-sell').forEach(el => el.remove());

    /* Shipping bar SIEMPRE arriba: insertar como primer hijo del .cart-drawer__inner */
    inner.insertBefore(buildShippingBar(cart), inner.firstChild);

    /* Cross-sell SIEMPRE abajo: como último hijo del .cart-drawer__inner */
    const products = await loadRecommended();
    const cross = buildCrossSell(products, cart);
    if (cross) inner.appendChild(cross);
  }

  /* Vigilar el dialog: cuando cambia 'open' o cuando Horizon re-renderiza el contenido interno, re-injectamos las extras */
  function watchDialog(){
    const dialog = findDialog();
    if (!dialog) {
      setTimeout(watchDialog, 600);
      return;
    }

    /* Observar atributos del dialog para detectar open/close */
    new MutationObserver(() => {
      if (dialogIsOpen(dialog)) setTimeout(renderExtras, 80);
    }).observe(dialog, { attributes: true, attributeFilter: ['open','class'] });

    /* Observar cambios dentro del dialog (Horizon morphing al actualizar carrito)
       y re-inyectar si las extras desaparecen */
    new MutationObserver(() => {
      if (!dialogIsOpen(dialog)) return;
      const inner = dialog.querySelector('.cart-drawer__inner');
      if (!inner) return;
      const hasShip = inner.querySelector(':scope > .idk-shipping-bar');
      const hasCross = inner.querySelector(':scope > .idk-cross-sell');
      if (!hasShip || !hasCross) {
        renderExtras();
      }
    }).observe(dialog, { childList: true, subtree: true });

    if (dialogIsOpen(dialog)) renderExtras();
  }

  /* También re-render en eventos clásicos de carrito */
  ['cart:refresh','cart:updated','cart:added','cart:open'].forEach(ev => {
    document.addEventListener(ev, () => setTimeout(renderExtras, 100));
    window.addEventListener(ev, () => setTimeout(renderExtras, 100));
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    watchDialog();
  } else {
    document.addEventListener('DOMContentLoaded', watchDialog);
  }
})();
